import './supTripStrap.css';
import Calendar from '../../assets/icons/trvto_calendar.svg';
import ReviewStars from '../reviewStars/ReviewStars';
import { getAmenities } from './tripStrapFun/amenities';
import image1 from '../../assets/images/trvto_tripDetails.jpg';
import { toPascalCase } from '../../utils/pascalCase';
import EditIcon from '../../assets/icons/trvto_edit_icon.svg';
import DeleteIcon from '../../assets/icons/trvto_deleteIcon.svg';
import DuplicateIcon from '../../assets/icons/trvto_duplicate.png';
import { ReactComponent as InactiveIcon } from '../../assets/icons/inactive-icons.svg';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import { share } from '../../pages/tripDetails/tripDetailsFun/tripDetailsShare';
import { useParams } from 'react-router-dom';
import { supBookingStatusChange, supOrgTripDelFun, supTripEdit } from '../../api/supportAdmin';
import errorHandle from '../../utils/errorHandle';
import { toast } from 'react-toastify';
import { useState } from 'react';
import ConfirmationModal from '../tripStrap/tripStrapFun/cancelBooking';
import Tooltip from '../tooltip/Tooltip';

export default function SupTripStrap({ page, setNav, data, setSelectedPack, selectedStatus, refresh, serviceType }) {
    const [showModal, setShowModal] = useState(false);
    const [showInactiveStatusModal, setShowInactiveStatusModal] = useState(false);
    const [tripId, setTripId] = useState('');
    const { orgId, mode } = useParams();

    async function deletepack(id) {
        try {
            const result = await supOrgTripDelFun('trip', id);

            if (result.status === 200) {
                toast.success('Package deleted successfully');
                setShowModal(false);
                refresh();
            } else {
                toast.error('Failed to delete the package');
            }
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    async function handleToggle(checked, data, type) {
        try {
            const updateData = {
                _id: data._id
            };

            if (type === 'createDate') {
                updateData.createDate = checked;
            }

            if (type === 'appOnly') {
                updateData.appOnly = checked;
            }

            const result = await supTripEdit('trip', updateData);

            if (result.status === 200) {
                if (type === 'createDate') {
                    toast.success(checked ? 'Auto-generate dates enabled.' : 'Auto-generate dates disabled.');
                }

                if (type === 'appOnly') {
                    toast.success(checked ? 'App Only enabled.' : 'App Only disabled.');
                }

                setShowModal(false);
                refresh();
            } else {
                toast.error('Unable to update setting. Please try again.');
            }
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    async function inactiveTripPack(id, serviceType) {
        try {
            const data = {
                type: serviceType,
                _id: id,
                status: 'inactive'
            };
            const result = await supBookingStatusChange(data);
            if (result.status === 200) {
                toast.success('Package Inactivated successfully');
                setShowInactiveStatusModal(false);
                refresh();
            }
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    const handleTrip = (e, tripData, type) => {
        e.stopPropagation();
        if (type === 'delete') {
            setShowModal(true);
            setTripId(tripData._id);
            return;
        } else if (type === 'inactive') {
            setShowInactiveStatusModal(true);
            setTripId(tripData._id);
            return;
        }
        const url = `/support/${mode}/create/pack/${orgId}?new=false&type=${type}&tripId=${tripData._id}`;
        window.open(url, '_blank');
    };

    return (
        <div>
            {selectedStatus === 'rejected' && (
                <div className='note-section'>
                    <p>
                        Note:{' '}
                        <span>
                            Click on the package to view the rejection comment. You can edit and resubmit the package.
                        </span>
                    </p>
                </div>
            )}
            {data?.map((data) => (
                <div
                    key={data._id}
                    className='org_tripStrap'
                    onClick={() => {
                        setNav(true);
                        setSelectedPack(data._id);
                    }}
                >
                    <div className='org_tripStrapContent'>
                        <div className='org_thumbImageContainer'>
                            <img
                                src={data.cardImages[0] ?? image1}
                                alt='trvto_trip'
                                className='org_tripStrapImage'
                                loading='lazy'
                                decoding='async'
                            />
                        </div>
                        <div className='org_tripStrapInfoDiv'>
                            <div className='org_tripStrapNameDiv alignCenter'>
                                <div className='org_tripStrapInfo'>
                                    <div className='org_tripStrapName'>
                                        <div className='alignCenter'>
                                            <p>{data?.title}</p>{' '}
                                            <Share className='deskHidden' onClick={(e) => share(e)} />
                                        </div>
                                        <div className='org_tripInfo'>
                                            {Array.isArray(data?.quickView?.type) &&
                                                data.quickView.type.includes('Trek') && (
                                                    <div className='org_typeInfo'>{data.quickView.type[0]}</div>
                                                )}
                                            <div className={`org_typeInfo ${data?.quickView?.difficulty}`}>
                                                {data?.quickView?.difficulty}
                                            </div>{' '}
                                            <div
                                                className={`org_typeInfo ${data?.status === 'active' ? 'active' : ''}`}
                                            >
                                                {toPascalCase(data?.status || ' ')}
                                            </div>
                                            <Share className='mobileHidden' onClick={(e) => share(e)} />
                                        </div>
                                    </div>
                                    <div className='org_tripCardNumInfo'>
                                        <ReviewStars rating={data?.rating} />
                                        <span>{data?.rating}</span>
                                        <p style={{ margin: 0 }}>({data?.reviewCount} Reviews)</p>
                                    </div>

                                    {data.type === 'rooms' && (
                                        <div className='org_amenities'>{getAmenities(data?.quickView?.amenities)}</div>
                                    )}
                                    {Array.isArray(data.quickView?.type) && data.quickView.type.includes('Trek') && (
                                        <div className='org_tripStrapDateDetails'>
                                            <div className='alignCenter'>
                                                <img src={Calendar} width={24} height={24} alt='trvto_calendar' />
                                                <span>
                                                    {data?.days} D, {data?.nights} N
                                                </span>
                                                <div className='divider' />
                                                <span className='innerStrap'>
                                                    <span className='innerStrapColumn'>
                                                        <span>{data?.quickView?.startTime}</span>
                                                        <label>|</label>
                                                        <span>{data?.quickView?.endTime}</span>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {data.datesType === 'fixed' && (
                                    <div className='org_tripStrapPriceDiv'>
                                        <div className='org_tripStrapPrDiv'>
                                            <p className='org_tripStrapPrice'>
                                                ₹ {Math.round(data?.price[0]?.price?.total)}
                                                <span>/person</span>
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{ display: 'flex' }}>
                                <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'duplicate')}>
                                    <Tooltip content={'Duplicate'} position='bottom' className='tooltip-large'>
                                        <img src={DuplicateIcon} alt='duplicate' width={36} height={36} />
                                    </Tooltip>
                                </button>
                                <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'edit')}>
                                    <Tooltip content={'Edit'} position='bottom' className='tooltip-large'>
                                        <img src={EditIcon} alt='edit' width={36} height={36} />
                                    </Tooltip>
                                </button>
                                <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'delete')}>
                                    <Tooltip content={'Delete'} position='bottom' className='tooltip-large'>
                                        <img src={DeleteIcon} alt='delete' width={36} height={36} />
                                    </Tooltip>
                                </button>
                                {selectedStatus === 'active' && (
                                    <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'inactive')}>
                                        <Tooltip content={'Inactive'} position='bottom' className='tooltip-large'>
                                            <InactiveIcon width={36} height={36} color='#EF4444 ' />
                                        </Tooltip>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='toggle-wrap' onClick={(e) => e.stopPropagation()}>
                        <span className='toggle-label'>Auto-generate Dates</span>
                        <label className='toggleTripStrap'>
                            <input
                                type='checkbox'
                                checked={data.createDate}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    handleToggle(e.target.checked, data, 'createDate');
                                }}
                            />
                            <span className='toggle-track' />
                            <span className='toggle-thumb' />
                        </label>
                        <span className='toggle-divider'></span>
                        <span className='toggle-label'>App Only</span>
                        <label className='toggleTripStrap'>
                            <input
                                type='checkbox'
                                checked={data?.appOnly}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    handleToggle(e.target.checked, data, 'appOnly');
                                }}
                            />
                            <span className='toggle-track' />
                            <span className='toggle-thumb' />
                        </label>
                        {/* <span className={data.createDate ? 'toggle-status on' : 'toggle-status off'}>
                                    {data.createDate ? 'On' : 'Off'}
                                </span> */}
                    </div>
                    <div>
                        {Array.isArray(data.quickView?.type) && data.quickView.type.includes('Trek') && (
                            <>
                                <div className='org_tripDivider org_holidayDivider' />
                                <p className='org_locationInfo'>
                                    Pickup Cities: <span>{data?.quickView?.baseCities}</span>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            ))}
            {showModal && (
                <ConfirmationModal
                    setShowModal={setShowModal}
                    handleConfirm={() => deletepack(tripId)}
                    message={'Do you want to delete the pack?'}
                />
            )}
            {showInactiveStatusModal && (
                <ConfirmationModal
                    setShowModal={setShowInactiveStatusModal}
                    handleConfirm={() => inactiveTripPack(tripId, serviceType)}
                    message={'Do you want to make trip package as incative?'}
                />
            )}
        </div>
    );
}
